import { format } from "date-fns";

type DateFormatType = 'international' | 'us';

const DATE_FORMAT_STORAGE_KEY = 'user_date_format';

/**
 * Get the user's date format preference from localStorage.
 * Defaults to 'international' if not set.
 */
function getDateFormatPreference(): DateFormatType {
  const stored = localStorage.getItem(DATE_FORMAT_STORAGE_KEY);
  if (stored === 'us' || stored === 'international') {
    return stored;
  }
  return 'international';
}

/**
 * Format a date according to user's preference.
 * @param date - Date object, ISO string, or timestamp
 * @param includeTime - Whether to include time in the output
 * @returns Formatted date string
 */
export function formatDate(
  date: Date | string | number,
  includeTime: boolean = false
): string {
  try {
    const dateObj = typeof date === 'string' || typeof date === 'number'
      ? new Date(date)
      : date;

    if (isNaN(dateObj.getTime())) {
      return '';
    }

    const dateFormat = getDateFormatPreference();

    if (dateFormat === 'us') {
      // US format: MM/DD/YYYY
      return includeTime
        ? format(dateObj, 'MM/dd/yyyy, h:mm a')
        : format(dateObj, 'MM/dd/yyyy');
    } else {
      // International format: DD/MM/YYYY
      return includeTime
        ? format(dateObj, 'dd/MM/yyyy, HH:mm')
        : format(dateObj, 'dd/MM/yyyy');
    }
  } catch (error) {
    return '';
  }
}
